import { render, staticRenderFns } from "./PAttachment.vue?vue&type=template&id=9ba0fc0a&scoped=true"
import script from "./PAttachment.vue?vue&type=script&lang=js"
export * from "./PAttachment.vue?vue&type=script&lang=js"
import style0 from "./PAttachment.vue?vue&type=style&index=0&id=9ba0fc0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba0fc0a",
  null
  
)

export default component.exports